import './App.less'
import './layout/common.scss'
import React, { useEffect, useMemo, useState } from 'react'
import { Spin } from 'antd'
import { renderRoutes } from './config/routes'
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute'
import { Switch, Route } from 'react-router-dom'
import { AuthContext } from './store/auth'
import AppLogout from './components/AppLogout/AppLogout'
import { useAuth } from './utils/hooks/authHook'
import { getCurrentRoleRoutes } from './utils/helperFunctions/helperFunctions'
import NotFound from './pages/NotFound/NotFound'
import { useNavigatorOnLine } from './utils/hooks/useNavigatorOnline'
import Nointernet from './components/NoInternet/NoInternet'
import AuthVerify from './utils/AuthVerify'

function App() {
  const isOnline = useNavigatorOnLine()
  const { login, logout, token, userId, userRole, roleLoading } = useAuth()
  const [currentUserRoutes, setCurrentUserRoutes] = useState([])

  const authContextValue = useMemo(
    () => ({
      token: token,
      userId: userId, 
      userRole: userRole,
      roleLoading: roleLoading,
      login: login,
      logout: logout,
    }),
    [token, userId, userRole, roleLoading, login, logout]
  )
  useEffect(() => {
    const currentUserRoleRoutes = getCurrentRoleRoutes(renderRoutes, userRole)
    setCurrentUserRoutes(currentUserRoleRoutes)
  }, [userRole])

  // Block route rendering while the backend role fetch is in progress for a
  // logged-in user. This prevents routes from briefly rendering with an empty
  // role, which could expose unauthorized pages before the API response arrives.
  const isResolvingRole = !!userId && roleLoading

  return (
    <div className="App">
      <Nointernet isOnline={isOnline} />
      <AuthContext.Provider value={authContextValue}>
        <AppLogout>
          {isResolvingRole ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '100vh',
              }}
            >
              <Spin size="large" />
            </div>
          ) : (
            <Switch>
              {currentUserRoutes.map(([key, route]) => (
                <Route
                  key={key}
                  path={route.path}
                  exact={route.exact}
                  render={(props) => {
                    const dynamicKey =
                      props.match?.params?.id ||
                      props.match?.params?.fetchParam ||
                      key
                    return (
                      <ProtectedRoute
                        {...{ route }}
                        componentKey={dynamicKey}
                        {...props}
                      />
                    )
                  }}
                />
              ))}
              {currentUserRoutes.length > 0 && (
                <Route>
                  <NotFound />
                </Route>
              )}
            </Switch>
          )}
        </AppLogout>
        <AuthVerify logout={logout} />
      </AuthContext.Provider>
    </div>
  )
}
export default App
